export type { ShoppingCartProps } from './shopping-cart';
export * from './shopping-cart.routes';

export { default as ShoppingCart, default } from './shopping-cart';
